import request from '@/utils/request'

// ── 认证 ──
export function login(data)    { return request({ url: '/login',   method: 'post', data }) }
export function getUserInfo()  { return request({ url: '/getInfo', method: 'get' }) }

// ── 时序事项 ──
export function listSequences(params) {
  return request({ url: '/todo/sequence/list', params })
}
export function getCalendar(startDate, endDate) {
  return request({ url: '/todo/sequence/calendar', params: { startDate, endDate } })
}
export function getSequence(id) {
  return request({ url: `/todo/sequence/${id}` })
}
export function addSequence(data) {
  return request({ url: '/todo/sequence', method: 'post', data })
}
export function updateSequence(data) {
  return request({ url: '/todo/sequence', method: 'put', data })
}
export function deleteSequence(id) {
  return request({ url: `/todo/sequence/${id}`, method: 'delete' })
}

// ── 不关注时序 ──
export function getMyBlackIds() {
  return request({ url: '/todo/sequence-black/my-black-ids', method: 'get' })
}
export function blackSequence(sequenceId) {
  return request({ url: `/todo/sequence-black/black/${sequenceId}`, method: 'post' })
}
export function unblackSequence(sequenceId) {
  return request({ url: `/todo/sequence-black/unblack/${sequenceId}`, method: 'delete' })
}

// ── 交易主体 ──
export function listEntities(params) {
  return request({ url: '/todo/entity/list', params })
}
export function addEntity(data)    { return request({ url: '/todo/entity', method: 'post', data }) }
export function updateEntity(data) { return request({ url: '/todo/entity', method: 'put',  data }) }
export function deleteEntity(id)   { return request({ url: `/todo/entity/${id}`, method: 'delete' }) }

export function listAccounts(entityId, params) {
  return request({ url: `/todo/entity/${entityId}/accounts`, params })
}
export function addAccount(data)    { return request({ url: '/todo/entity/account', method: 'post', data }) }
export function updateAccount(data) { return request({ url: '/todo/entity/account', method: 'put',  data }) }
export function deleteAccount(id)   { return request({ url: `/todo/entity/account/${id}`, method: 'delete' }) }
export function getCurrentAccount()  { return request({ url: '/todo/entity/currentAccount' }) }

// ── PDF 导入 ──
export function listImportRecords() { return request({ url: '/todo/import/records' }) }
export function uploadPdf(formData) {
  return request({ url: '/todo/import/upload', method: 'post', data: formData,
    headers: { 'Content-Type': 'multipart/form-data' } })
}
export function listPendingItems()           { return request({ url: '/todo/import/pending' }) }
export function listItemsByRecord(recordId)  { return request({ url: `/todo/import/items/${recordId}` }) }
export function approveItem(itemId)          { return request({ url: `/todo/import/approve/${itemId}`,   method: 'post' }) }
export function rejectItem(itemId)           { return request({ url: `/todo/import/reject/${itemId}`,    method: 'post' }) }
export function approveAll(recordId)         { return request({ url: `/todo/import/approveAll/${recordId}`, method: 'post' }) }
export function updateImportItem(data)       { return request({ url: '/todo/import/item', method: 'put', data }) }
export function deleteImportRecord(id)       { return request({ url: `/todo/import/record/${id}`, method: 'delete' }) }

// ── 接口管理 ──
export function listApiSystems()   { return request({ url: '/todo/api/systems' }) }
export function addApiSystem(data) { return request({ url: '/todo/api/system', method: 'post', data }) }
export function updateApiSystem(data) { return request({ url: '/todo/api/system', method: 'put', data }) }
export function disableApiSystem(id) { return request({ url: `/todo/api/system/${id}`, method: 'delete' }) }
export function listApiTasks(status) { return request({ url: '/todo/api/tasks', params: status ? { status } : {} }) }
export function approveApiTask(id)  { return request({ url: `/todo/api/task/approve/${id}`, method: 'post' }) }
export function rejectApiTask(id)   { return request({ url: `/todo/api/task/reject/${id}`,  method: 'post' }) }

// ── 拨号记录 ──
export function listNotifyLogs(params) { return request({ url: '/todo/notify/logs', params }) }
export function getNotifyStat(year, month, params = {}) {
  return request({ url: '/todo/notify/stat', params: { year, month, ...params } })
}

// ── 用户自定义颜色 ──
export function getUserColorList() { return request({ url: '/todo/userColor/list', method: 'get' }) }
export function updateUserColor(priority, color) { return request({ url: '/todo/userColor/update', method: 'put', params: { priority, color } }) }